export enum TipoTermoFiscalEnum {

  NOTIFICACAO = "Notificação",
  TERMO_AUTOINFRACAO = "Termo de Auto de Infração",
  TERMO_ENCERRAMENTO = "Termo de Encerramento",
  TERMO_INICIOFISCALIZACAO = "Termo Início de Fiscalização"
}
